<template>
    <div v-loading="loading">
        <card-box class="order_list" title="订单支付">
            <el-button  @click="back" slot="tt_r" type="primary" class="butn">返回</el-button>
            <div class="test">
                订单编号：{{orderCode}}
            </div>
            <el-table
                    :data="myOrder"
                    header-row-class-name="myOrder-header"
                    style="width: 100%;"
                    row-class-name="order"
                    class="myOrder_tb"
                    height="100%"
                    stripe
                    :header-cell-style="{height: '40px',background:'rgba(245,247,246,1)'}"
            >
                <el-table-column width="250" prop="mealName" align="center" label="套餐名称"></el-table-column>
                <el-table-column prop="setmealNum" align="center" label="数量"></el-table-column>
                <el-table-column align="center" width="100" label="金额">
                    <template slot-scope="scope"><i class="iconfont icon-renminbidanjia2 i_fon_s"></i> {{scope.row.orderAmount}}</template>
                </el-table-column>
            </el-table>
            <div class="test_buttom">
                应支付金额：<span><i class="iconfont icon-renminbidanjia2 i_fon"></i>{{orderAmount}}</span>
            </div>
            <div class="buttom" @dblclick="shishiClick()">
                <el-radio-group v-model="radio1" >
                    <el-radio-button label="0" class="list wei"></el-radio-button>
                    <el-radio-button label="1" class="list zhi" ></el-radio-button>
                    <el-radio-button label="2" class="list yin"></el-radio-button>
                </el-radio-group>
            </div>
            <div  class="buttom">
                <el-button :loading="loding_s" class="buttom_button"  type="primary" @click="immediately_Buy()">立即购买</el-button>
            </div>
        </card-box>
    </div>
</template>

<script>
    export default {
        name: "paymentMethod",
        data(){
            return {
                myOrder: [],
                orderCode:'',
                orderAmount:'',
                radio1: '1',
                loding_s:false,
                loading:false,
            }
        },
        created() {
            this.code = this.$route.params.code;
            if(this.$route.params.id){
                this.bay_queryEntity(this.$route.params.id)
            }else {
                this.Buy(this.code)
            }
        },
        // /guodun-serve-manage-lzm/function/buy/meal
        methods:{
            back() {
                this.$router.go(-1); //返回上一层
                if(this.$route.params.id){
                    this.$router.push({name: 'myOrder', params:{signRule:'待支付'}})
                }
            },
            shishiClick(){
                this.immediately_Buy()
            },
            Buy(i){
                this.loading = true
                this.$SIF.httpPost({
                    url: this.$SIF._serve.manage + "/function/buy/meal",
                    data: {
                        code: i,
                        num: '1'
                    },
                    succFun: res => {
                        this.bay_queryEntity(res.data.id)
                    },failFun:res=>{
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            bay_queryEntity(id){
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/appOrderController/queryEntity",
                    data: {
                        id: id,
                    },
                    succFun: res => {
                        this.myOrder.push(res.data)
                        this.orderCode = res.data.orderCode
                        this.orderAmount = res.data.orderAmount
                        this.orId = id
                        this.loading = false
                    },failFun:res=>{
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            immediately_Buy(){
                if(this.radio1 == 0){
                    this.url = this.$SIF._serve.pay + "/functron/wxQRApplet"
                }else if(this.radio1 == 1){
                    this.url = this.$SIF._serve.pay + "/functron/zfbQRApplet"
                }else {
                    this.url = this.$SIF._serve.pay + "/functron/createPayQr"
                }
                var pagename_one = window.location.host
                if (pagename_one.indexOf("aiosign.com") >= 0) {
                    this.new_url = 'https://' + pagename_one
                } else {
                    this.new_url = this.$SIF.get_url
                }
                this.loding_s = true;
                this.$SIF.httpPost({
                    url: this.url,
                    data: {
                        ...this.myOrder[0],
                        invoiceState:0,
                        returnUrl: this.new_url+'/web/index.html#/',
                    },
                    succFun: res => {
                        if(this.radio1 == 0){
                            this.$SIF.setLocalStorage('qrCodeBase64', res.data.qrCodeBase64)
                            this.$router.push({name: 'pay_window', params:{radio1:this.radio1,id:this.orId,opid:this.$route.params.id}})
                            // let routeData = this.$router.resolve({ name: 'pay_window', query: {code : res.data.qrCodeBase64,radio1:this.radio1,id:this.orId}});
                            // window.open(routeData.href, '_self');
                        }else if(this.radio1 == 1){
                            this.$SIF.setLocalStorage('qrCodeBase64', res.data.qr_base64)
                            this.$router.push({name: 'pay_window', params:{radio1:this.radio1,id:this.orId,opid:this.$route.params.id}})
                            // let routeData = this.$router.resolve({ name: 'pay_window', query: {code : res.data.qr_base64,radio1:this.radio1,id:this.orId}});
                            // window.open(routeData.href, '_self');
                        }else {
                            this.$SIF.setLocalStorage('qrCodeBase64', res.data.qrCodeBase64)
                            this.$router.push({name: 'pay_window', params:{radio1:this.radio1,id:this.orId,opid:this.$route.params.id}})
                            // let routeData = this.$router.resolve({ name: 'pay_window', query: {code : res.data.qrCodeBase64,radio1:this.radio1,id:this.orId}});
                            // window.open(routeData.href, '_self');
                        }
                        this.loding_s = false;
                    },failFun:res=>{
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                        this.loding_s = false;
                    }
                });
            }
        }

    }
</script>

<style scoped type="text/css">
    .butn{
        position: absolute;
        left: 20px;
        top:5px;
    }
    .order_list/deep/.card-box-tt{
        padding-left:90px !important;
    }
    .order_list {
        height: calc(100% - 300px);
    }
    .test{
        color: #999999;
        font-size: 14px;
        padding: 10px 20px;
    }
    .test_buttom{
        padding: 0 20px;
        text-align: right;
        font-size: 14px;
        color: #999999;
    }
    .test_buttom span{
        font-size: 21px;
        color: #31CA84;
    }
    .i_fon{
        font-size: 21px;
    }
    .i_fon_s{
        font-size: 14px;
    }
    .buttom{
        width: 80%;
        text-align: center;
        margin: 0 auto;
        padding: 20px 0;
    }
    .wei{ background:url(~@/assets/img/user/weix.png) center ;}
    .zhi{ background:url(~@/assets/img/user/zhif.png) center ;}
    .yin{ background:url(~@/assets/img/user/yinl.png) center ;}
    .list{
        background-repeat:no-repeat;
        background-size: 80% 80%;
        width: 65px;
        height: 65px;
        margin-right: 21px;
        color: rgba(0,0,0,0);
    }
    .myOrder_tb >>> .el-table__row {
        height: 40px;
    }
    .list /deep/ .el-radio-button__inner{
        background: none;
        box-shadow: none;
        border: none;
        color: rgba(0,0,0,0);
    }
    .is-active{
        width: 65px;
        height: 65px;
        border:  2px solid #1c965e !important;
        border-radius: 50%;
        color: rgba(0,0,0,0);
    }
    .buttom_button{
        border-radius:8px;
        font-size:16px;
    }

</style>